<template>
    <vue-final-modal
        v-model="show"
        name="welcome-modal"
        classes="vizion-modal-container"
        content-class="vizion-modal-content"
        :esc-to-close="escToClose"
    >
        <button class="vizion-modal-close" @click="handleClose">
            <i class="fas fa-times"></i>
        </button>

        <h3 class="vizion-modal-title" v-if="title">
            {{ title }}
        </h3>

        <figure v-if="image">
            <img :src="`/storage/${image}`" :alt="title">
        </figure>

        <div v-html="content"></div>

        <div class="vizion-modal-actions" v-if="btnText && btnLink">
            <a :href="btnLink">
                {{ btnText }}
            </a>
        </div>
    </vue-final-modal>
</template>

<script>
import { inject, onMounted, ref, watch } from 'vue'

export default {

    emits: ['closed'],

    props: [
        'title',
        'content',
        'btnText',
        'btnLink',
        'image',
        'open'
    ],

    setup(props, {emit}) {
        const $vfm       = inject('$vfm'),
            escToClose = ref(true);

        let show = ref(false);

        onMounted( () => {
            show.value = props.open
        })

        watch( () => props.open, (newValue) => {
            show.value = newValue
        })

        function handleClose() {
            show.value = false;
            emit('closed')
        }

        return {
            show,
            escToClose,
            handleClose,
            $vfm
        }
    }
}
</script>
